import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/tmp/8df0f255e036290/components/blog/ReadingProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8df0f255e036290/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/tmp/8df0f255e036290/components/blog/TableOfContents.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/components/blog/PrevNextNav.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0f255e036290/node_modules/next/dist/client/link.js");
